import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { recommendPopupPath, RecommendPopupUrlQueryParams } from "./urls";
import RecommendPopupComponent from "./views/RecommendPopup";

const recommendPopup: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: RecommendPopupUrlQueryParams = qs;
  return <RecommendPopupComponent params={params} />;
};
export const RecommendPopupSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.recommendPopup)} />
      <Switch>
        <Route exact path={recommendPopupPath} component={recommendPopup} />
      </Switch>
    </>
  );
};
export default RecommendPopupSection;
